//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

export class SnapshotsApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    get(interval: string | undefined, signal?: AbortSignal): Promise<Snapshots> {
        let url_ = this.baseUrl + "/api/snapshots?";
        if (interval === null)
            throw new globalThis.Error("The parameter 'interval' cannot be null.");
        else if (interval !== undefined)
            url_ += "interval=" + encodeURIComponent("" + interval) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<Snapshots> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Snapshots.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Snapshots>(null as any);
    }
}

export class ClientAuthenticationApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getJavaScriptClient(signal?: AbortSignal): Promise<JavaScriptClientDto> {
        let url_ = this.baseUrl + "/api/authentication/javascript-client";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetJavaScriptClient(_response);
        });
    }

    protected processGetJavaScriptClient(response: Response): Promise<JavaScriptClientDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JavaScriptClientDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<JavaScriptClientDto>(null as any);
    }
}

export class ClientAuthorisationApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    isAuthorised(policies: string[] | null | undefined, signal?: AbortSignal): Promise<IsAuthorisedDto> {
        let url_ = this.baseUrl + "/api/authorisation/is-authorised?";
        if (policies !== undefined && policies !== null)
            policies && policies.forEach(item => { url_ += "policies=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processIsAuthorised(_response);
        });
    }

    protected processIsAuthorised(response: Response): Promise<IsAuthorisedDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IsAuthorisedDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IsAuthorisedDto>(null as any);
    }
}

export class Snapshots implements ISnapshots {
    current?: Snapshot;
    previous?: Snapshot;

    constructor(data?: ISnapshots) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.current = _data["current"] ? Snapshot.fromJS(_data["current"]) : undefined as any;
            this.previous = _data["previous"] ? Snapshot.fromJS(_data["previous"]) : undefined as any;
        }
    }

    static fromJS(data: any): Snapshots {
        data = typeof data === 'object' ? data : {};
        let result = new Snapshots();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current ? this.current.toJSON() : undefined as any;
        data["previous"] = this.previous ? this.previous.toJSON() : undefined as any;
        return data;
    }
}

export interface ISnapshots {
    current?: Snapshot;
    previous?: Snapshot;
}

export class Snapshot implements ISnapshot {
    id?: string;
    date?: string;
    interval?: string;
    intervention?: boolean;
    suspension?: boolean;
    administered?: boolean;
    suspendedRegions?: string[];
    administeredRegions?: string[];
    physical?: SnapshotDetail;
    financial?: SnapshotDetail;

    constructor(data?: ISnapshot) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.date = _data["date"];
            this.interval = _data["interval"];
            this.intervention = _data["intervention"];
            this.suspension = _data["suspension"];
            this.administered = _data["administered"];
            if (Array.isArray(_data["suspendedRegions"])) {
                this.suspendedRegions = [] as any;
                for (let item of _data["suspendedRegions"])
                    this.suspendedRegions!.push(item);
            }
            if (Array.isArray(_data["administeredRegions"])) {
                this.administeredRegions = [] as any;
                for (let item of _data["administeredRegions"])
                    this.administeredRegions!.push(item);
            }
            this.physical = _data["physical"] ? SnapshotDetail.fromJS(_data["physical"]) : undefined as any;
            this.financial = _data["financial"] ? SnapshotDetail.fromJS(_data["financial"]) : undefined as any;
        }
    }

    static fromJS(data: any): Snapshot {
        data = typeof data === 'object' ? data : {};
        let result = new Snapshot();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["date"] = this.date;
        data["interval"] = this.interval;
        data["intervention"] = this.intervention;
        data["suspension"] = this.suspension;
        data["administered"] = this.administered;
        if (Array.isArray(this.suspendedRegions)) {
            data["suspendedRegions"] = [];
            for (let item of this.suspendedRegions)
                data["suspendedRegions"].push(item);
        }
        if (Array.isArray(this.administeredRegions)) {
            data["administeredRegions"] = [];
            for (let item of this.administeredRegions)
                data["administeredRegions"].push(item);
        }
        data["physical"] = this.physical ? this.physical.toJSON() : undefined as any;
        data["financial"] = this.financial ? this.financial.toJSON() : undefined as any;
        return data;
    }
}

export interface ISnapshot {
    id?: string;
    date?: string;
    interval?: string;
    intervention?: boolean;
    suspension?: boolean;
    administered?: boolean;
    suspendedRegions?: string[];
    administeredRegions?: string[];
    physical?: SnapshotDetail;
    financial?: SnapshotDetail;
}

export class SnapshotDetail implements ISnapshotDetail {
    regions?: { [key: string]: RegionSnapshot; };
    interconnectors?: { [key: string]: InterconnectorSnapshot; };

    constructor(data?: ISnapshotDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["regions"]) {
                this.regions = {} as any;
                for (let key in _data["regions"]) {
                    if (_data["regions"].hasOwnProperty(key))
                        (this.regions as any)![key] = _data["regions"][key] ? RegionSnapshot.fromJS(_data["regions"][key]) : new RegionSnapshot();
                }
            }
            if (_data["interconnectors"]) {
                this.interconnectors = {} as any;
                for (let key in _data["interconnectors"]) {
                    if (_data["interconnectors"].hasOwnProperty(key))
                        (this.interconnectors as any)![key] = _data["interconnectors"][key] ? InterconnectorSnapshot.fromJS(_data["interconnectors"][key]) : new InterconnectorSnapshot();
                }
            }
        }
    }

    static fromJS(data: any): SnapshotDetail {
        data = typeof data === 'object' ? data : {};
        let result = new SnapshotDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.regions) {
            data["regions"] = {};
            for (let key in this.regions) {
                if (this.regions.hasOwnProperty(key))
                    (data["regions"] as any)[key] = this.regions[key] ? this.regions[key].toJSON() : undefined as any;
            }
        }
        if (this.interconnectors) {
            data["interconnectors"] = {};
            for (let key in this.interconnectors) {
                if (this.interconnectors.hasOwnProperty(key))
                    (data["interconnectors"] as any)[key] = this.interconnectors[key] ? this.interconnectors[key].toJSON() : undefined as any;
            }
        }
        return data;
    }
}

export interface ISnapshotDetail {
    regions?: { [key: string]: RegionSnapshot; };
    interconnectors?: { [key: string]: InterconnectorSnapshot; };
}

export class RegionSnapshot implements IRegionSnapshot {
    prices?: RegionPrices;

    constructor(data?: IRegionSnapshot) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prices = _data["prices"] ? RegionPrices.fromJS(_data["prices"]) : undefined as any;
        }
    }

    static fromJS(data: any): RegionSnapshot {
        data = typeof data === 'object' ? data : {};
        let result = new RegionSnapshot();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prices"] = this.prices ? this.prices.toJSON() : undefined as any;
        return data;
    }
}

export interface IRegionSnapshot {
    prices?: RegionPrices;
}

export class RegionPrices implements IRegionPrices {
    suspended?: boolean;
    energy?: number;
    energyFlags?: string[];
    raiseReg?: number;
    raiseRegFlags?: string[];
    raise1Sec?: number | undefined;
    raise1SecFlags?: string[];
    raise6Sec?: number;
    raise6SecFlags?: string[];
    raise60Sec?: number;
    raise60SecFlags?: string[];
    raise5Min?: number;
    raise5MinFlags?: string[];
    lowerReg?: number;
    lowerRegFlags?: string[];
    lower1Sec?: number | undefined;
    lower1SecFlags?: string[];
    lower6Sec?: number;
    lower6SecFlags?: string[];
    lower60Sec?: number;
    lower60SecFlags?: string[];
    lower5Min?: number;
    lower5MinFlags?: string[];

    constructor(data?: IRegionPrices) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.suspended = _data["suspended"];
            this.energy = _data["energy"];
            if (Array.isArray(_data["energyFlags"])) {
                this.energyFlags = [] as any;
                for (let item of _data["energyFlags"])
                    this.energyFlags!.push(item);
            }
            this.raiseReg = _data["raiseReg"];
            if (Array.isArray(_data["raiseRegFlags"])) {
                this.raiseRegFlags = [] as any;
                for (let item of _data["raiseRegFlags"])
                    this.raiseRegFlags!.push(item);
            }
            this.raise1Sec = _data["raise1Sec"];
            if (Array.isArray(_data["raise1SecFlags"])) {
                this.raise1SecFlags = [] as any;
                for (let item of _data["raise1SecFlags"])
                    this.raise1SecFlags!.push(item);
            }
            this.raise6Sec = _data["raise6Sec"];
            if (Array.isArray(_data["raise6SecFlags"])) {
                this.raise6SecFlags = [] as any;
                for (let item of _data["raise6SecFlags"])
                    this.raise6SecFlags!.push(item);
            }
            this.raise60Sec = _data["raise60Sec"];
            if (Array.isArray(_data["raise60SecFlags"])) {
                this.raise60SecFlags = [] as any;
                for (let item of _data["raise60SecFlags"])
                    this.raise60SecFlags!.push(item);
            }
            this.raise5Min = _data["raise5Min"];
            if (Array.isArray(_data["raise5MinFlags"])) {
                this.raise5MinFlags = [] as any;
                for (let item of _data["raise5MinFlags"])
                    this.raise5MinFlags!.push(item);
            }
            this.lowerReg = _data["lowerReg"];
            if (Array.isArray(_data["lowerRegFlags"])) {
                this.lowerRegFlags = [] as any;
                for (let item of _data["lowerRegFlags"])
                    this.lowerRegFlags!.push(item);
            }
            this.lower1Sec = _data["lower1Sec"];
            if (Array.isArray(_data["lower1SecFlags"])) {
                this.lower1SecFlags = [] as any;
                for (let item of _data["lower1SecFlags"])
                    this.lower1SecFlags!.push(item);
            }
            this.lower6Sec = _data["lower6Sec"];
            if (Array.isArray(_data["lower6SecFlags"])) {
                this.lower6SecFlags = [] as any;
                for (let item of _data["lower6SecFlags"])
                    this.lower6SecFlags!.push(item);
            }
            this.lower60Sec = _data["lower60Sec"];
            if (Array.isArray(_data["lower60SecFlags"])) {
                this.lower60SecFlags = [] as any;
                for (let item of _data["lower60SecFlags"])
                    this.lower60SecFlags!.push(item);
            }
            this.lower5Min = _data["lower5Min"];
            if (Array.isArray(_data["lower5MinFlags"])) {
                this.lower5MinFlags = [] as any;
                for (let item of _data["lower5MinFlags"])
                    this.lower5MinFlags!.push(item);
            }
        }
    }

    static fromJS(data: any): RegionPrices {
        data = typeof data === 'object' ? data : {};
        let result = new RegionPrices();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["suspended"] = this.suspended;
        data["energy"] = this.energy;
        if (Array.isArray(this.energyFlags)) {
            data["energyFlags"] = [];
            for (let item of this.energyFlags)
                data["energyFlags"].push(item);
        }
        data["raiseReg"] = this.raiseReg;
        if (Array.isArray(this.raiseRegFlags)) {
            data["raiseRegFlags"] = [];
            for (let item of this.raiseRegFlags)
                data["raiseRegFlags"].push(item);
        }
        data["raise1Sec"] = this.raise1Sec;
        if (Array.isArray(this.raise1SecFlags)) {
            data["raise1SecFlags"] = [];
            for (let item of this.raise1SecFlags)
                data["raise1SecFlags"].push(item);
        }
        data["raise6Sec"] = this.raise6Sec;
        if (Array.isArray(this.raise6SecFlags)) {
            data["raise6SecFlags"] = [];
            for (let item of this.raise6SecFlags)
                data["raise6SecFlags"].push(item);
        }
        data["raise60Sec"] = this.raise60Sec;
        if (Array.isArray(this.raise60SecFlags)) {
            data["raise60SecFlags"] = [];
            for (let item of this.raise60SecFlags)
                data["raise60SecFlags"].push(item);
        }
        data["raise5Min"] = this.raise5Min;
        if (Array.isArray(this.raise5MinFlags)) {
            data["raise5MinFlags"] = [];
            for (let item of this.raise5MinFlags)
                data["raise5MinFlags"].push(item);
        }
        data["lowerReg"] = this.lowerReg;
        if (Array.isArray(this.lowerRegFlags)) {
            data["lowerRegFlags"] = [];
            for (let item of this.lowerRegFlags)
                data["lowerRegFlags"].push(item);
        }
        data["lower1Sec"] = this.lower1Sec;
        if (Array.isArray(this.lower1SecFlags)) {
            data["lower1SecFlags"] = [];
            for (let item of this.lower1SecFlags)
                data["lower1SecFlags"].push(item);
        }
        data["lower6Sec"] = this.lower6Sec;
        if (Array.isArray(this.lower6SecFlags)) {
            data["lower6SecFlags"] = [];
            for (let item of this.lower6SecFlags)
                data["lower6SecFlags"].push(item);
        }
        data["lower60Sec"] = this.lower60Sec;
        if (Array.isArray(this.lower60SecFlags)) {
            data["lower60SecFlags"] = [];
            for (let item of this.lower60SecFlags)
                data["lower60SecFlags"].push(item);
        }
        data["lower5Min"] = this.lower5Min;
        if (Array.isArray(this.lower5MinFlags)) {
            data["lower5MinFlags"] = [];
            for (let item of this.lower5MinFlags)
                data["lower5MinFlags"].push(item);
        }
        return data;
    }
}

export interface IRegionPrices {
    suspended?: boolean;
    energy?: number;
    energyFlags?: string[];
    raiseReg?: number;
    raiseRegFlags?: string[];
    raise1Sec?: number | undefined;
    raise1SecFlags?: string[];
    raise6Sec?: number;
    raise6SecFlags?: string[];
    raise60Sec?: number;
    raise60SecFlags?: string[];
    raise5Min?: number;
    raise5MinFlags?: string[];
    lowerReg?: number;
    lowerRegFlags?: string[];
    lower1Sec?: number | undefined;
    lower1SecFlags?: string[];
    lower6Sec?: number;
    lower6SecFlags?: string[];
    lower60Sec?: number;
    lower60SecFlags?: string[];
    lower5Min?: number;
    lower5MinFlags?: string[];
}

export class InterconnectorSnapshot implements IInterconnectorSnapshot {
    flow?: number;
    direction?: string;
    isCapped?: boolean;
    importLimit?: number;
    exportLimit?: number;

    constructor(data?: IInterconnectorSnapshot) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.flow = _data["flow"];
            this.direction = _data["direction"];
            this.isCapped = _data["isCapped"];
            this.importLimit = _data["importLimit"];
            this.exportLimit = _data["exportLimit"];
        }
    }

    static fromJS(data: any): InterconnectorSnapshot {
        data = typeof data === 'object' ? data : {};
        let result = new InterconnectorSnapshot();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["flow"] = this.flow;
        data["direction"] = this.direction;
        data["isCapped"] = this.isCapped;
        data["importLimit"] = this.importLimit;
        data["exportLimit"] = this.exportLimit;
        return data;
    }
}

export interface IInterconnectorSnapshot {
    flow?: number;
    direction?: string;
    isCapped?: boolean;
    importLimit?: number;
    exportLimit?: number;
}

export class JavaScriptClientDto implements IJavaScriptClientDto {
    authority!: string;
    clientId!: string;
    redirectUrl!: string;
    silentRedirectUrl!: string;
    responseType!: string;
    scope!: string;
    postLogoutRedirectUrl!: string;

    constructor(data?: IJavaScriptClientDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.authority = _data["authority"];
            this.clientId = _data["clientId"];
            this.redirectUrl = _data["redirectUrl"];
            this.silentRedirectUrl = _data["silentRedirectUrl"];
            this.responseType = _data["responseType"];
            this.scope = _data["scope"];
            this.postLogoutRedirectUrl = _data["postLogoutRedirectUrl"];
        }
    }

    static fromJS(data: any): JavaScriptClientDto {
        data = typeof data === 'object' ? data : {};
        let result = new JavaScriptClientDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authority"] = this.authority;
        data["clientId"] = this.clientId;
        data["redirectUrl"] = this.redirectUrl;
        data["silentRedirectUrl"] = this.silentRedirectUrl;
        data["responseType"] = this.responseType;
        data["scope"] = this.scope;
        data["postLogoutRedirectUrl"] = this.postLogoutRedirectUrl;
        return data;
    }
}

export interface IJavaScriptClientDto {
    authority: string;
    clientId: string;
    redirectUrl: string;
    silentRedirectUrl: string;
    responseType: string;
    scope: string;
    postLogoutRedirectUrl: string;
}

export class IsAuthorisedDto implements IIsAuthorisedDto {
    isAuthorised!: boolean;

    constructor(data?: IIsAuthorisedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isAuthorised = _data["isAuthorised"];
        }
    }

    static fromJS(data: any): IsAuthorisedDto {
        data = typeof data === 'object' ? data : {};
        let result = new IsAuthorisedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isAuthorised"] = this.isAuthorised;
        return data;
    }
}

export interface IIsAuthorisedDto {
    isAuthorised: boolean;
}

export class SwaggerException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new SwaggerException(message, status, response, headers, null);
}